import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import CaseTermPicker from './CaseTermPicker';
import apiClient from '../../../../../Services/NetteApiClient';
import { Moment } from 'moment';
import { CustomTimePickerTime } from '../../../../BaseModule/Components/TimePickerCustom/TimePickerCustom';

loadDOMComponent({
	selector: 'react-case-term-picker',
	callback: ({ container, context }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const workplaceMemberId = container.getAttribute('workplaceMemberId');
		const workplaceCaseTypeId = container.getAttribute('workplaceCaseTypeId');
		const onSelect = container.getAttribute('onSelect');
		const minDate = container.getAttribute('minDate');
		const maxDate = container.getAttribute('maxDate');
		const preselectedDateTime = container.getAttribute('preselectedDateTime');

		const handleSelect = (data: CustomTimePickerTime) => {
			apiClient.post(onSelect, {
				...data,
			});
		};

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<CaseTermPicker
						workplaceId={workplaceId}
						workplaceMemberId={workplaceMemberId}
						workplaceCaseTypeId={workplaceCaseTypeId}
						onSelect={handleSelect}
						minDate={minDate}
						maxDate={maxDate}
						preselectedDateTime={preselectedDateTime ?? undefined}
					/>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
